import { render, staticRenderFns } from "./ComiteViejo.vue?vue&type=template&id=f3eb7874&scoped=true"
import script from "./ComiteViejo.vue?vue&type=script&lang=js"
export * from "./ComiteViejo.vue?vue&type=script&lang=js"
import style0 from "./ComiteViejo.vue?vue&type=style&index=0&id=f3eb7874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3eb7874",
  null
  
)

export default component.exports